var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-md navbar-dark fixed-top bg-dark p-2",staticStyle:{"height":"100px"}},[_c('div',{staticClass:"py-0 px-0 bg-dark w-100 h-100 d-flex"},[_c('div',{staticClass:"bg-success w-100 h-100",staticStyle:{"width":"100px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2088adda","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 411
// module chunks = 0